// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_grid from "../../commonapis/gen/buhta_common_v1_grid.js";
import * as Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity from "./buhta_idp_v1alpha1_admin_identity.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const GetIdentityRequest = Caml_module.init_mod([
      "proto/platformapis/gen/buhta_idp_v1alpha1_admin_identity_service.ml",
      1038,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const GetIdentityResponse = Caml_module.init_mod([
      "proto/platformapis/gen/buhta_idp_v1alpha1_admin_identity_service.ml",
      1101,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListIdentitiesRequest = Caml_module.init_mod([
      "proto/platformapis/gen/buhta_idp_v1alpha1_admin_identity_service.ml",
      1161,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListIdentitiesResponse = Caml_module.init_mod([
      "proto/platformapis/gen/buhta_idp_v1alpha1_admin_identity_service.ml",
      1221,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CreateIdentityRequest = Caml_module.init_mod([
      "proto/platformapis/gen/buhta_idp_v1alpha1_admin_identity_service.ml",
      1281,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CreateIdentityResponse = Caml_module.init_mod([
      "proto/platformapis/gen/buhta_idp_v1alpha1_admin_identity_service.ml",
      1341,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdateIdentityRequest = Caml_module.init_mod([
      "proto/platformapis/gen/buhta_idp_v1alpha1_admin_identity_service.ml",
      1402,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdateIdentityResponse = Caml_module.init_mod([
      "proto/platformapis/gen/buhta_idp_v1alpha1_admin_identity_service.ml",
      1465,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const IdentityData = Caml_module.init_mod([
      "proto/platformapis/gen/buhta_idp_v1alpha1_admin_identity_service.ml",
      1530,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.idp.v1alpha1.GetIdentityRequest";
}

function make(idOpt, expandOpt, param) {
  const id = idOpt !== undefined ? idOpt : "";
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  return {
          id: id,
          expand: expand
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            2,
            "expand",
            "expand"
          ],
          Ocaml_protoc_plugin__Spec.string,
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge(t1, t2) {
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          expand: Curry._2(merge_expand, t1.expand, t2.expand)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                      [
                        2,
                        "expand",
                        "expand"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      Ocaml_protoc_plugin__Spec.not_packed
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._3(serialize, writer, param.id, param.expand);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, expand) {
  return {
          id: id,
          expand: expand
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.idp.v1alpha1.GetIdentityRequest", spec(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.expand);
  };
}

function constructor$1(id, expand) {
  return {
          id: id,
          expand: expand
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.idp.v1alpha1.GetIdentityRequest", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetIdentityRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.idp.v1alpha1.GetIdentityResponse";
}

function make$1(identity, param) {
  return {
          identity: identity
        };
}

const $$let = Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity.Buhta.Idp.V1alpha1.Identity;

const merge_identity = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "identity",
            "identity"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge$1(t1, t2) {
  return {
          identity: Curry._2(merge_identity, t1.identity, t2.identity)
        };
}

function spec$1(param) {
  const $$let = Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity.Buhta.Idp.V1alpha1.Identity;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "identity",
                    "identity"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.identity);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(identity) {
  return {
          identity: identity
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.idp.v1alpha1.GetIdentityResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.identity);
  };
}

function constructor$3(identity) {
  return {
          identity: identity
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.idp.v1alpha1.GetIdentityResponse", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetIdentityResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.idp.v1alpha1.ListIdentitiesRequest";
}

function make$2(grid, param) {
  return {
          grid: grid
        };
}

const $$let$1 = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;

const merge_grid = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "grid",
            "grid"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

function merge$2(t1, t2) {
  return {
          grid: Curry._2(merge_grid, t1.grid, t2.grid)
        };
}

function spec$2(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "grid",
                    "grid"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._2(serialize$2, writer, param.grid);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(grid) {
  return {
          grid: grid
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.idp.v1alpha1.ListIdentitiesRequest", spec$2(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.grid);
  };
}

function constructor$5(grid) {
  return {
          grid: grid
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.idp.v1alpha1.ListIdentitiesRequest", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListIdentitiesRequest, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$3(param) {
  return ".buhta.idp.v1alpha1.ListIdentitiesResponse";
}

function make$3(identitiesOpt, param) {
  const identities = identitiesOpt !== undefined ? identitiesOpt : /* [] */0;
  return {
          identities: identities
        };
}

const $$let$2 = Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity.Buhta.Idp.V1alpha1.Identity;

const merge_identities = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            1,
            "identities",
            "identities"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$3(t1, t2) {
  return {
          identities: Curry._2(merge_identities, t1.identities, t2.identities)
        };
}

function spec$3(param) {
  const $$let = Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity.Buhta.Idp.V1alpha1.Identity;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    1,
                    "identities",
                    "identities"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      }),
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry._2(serialize$3, writer, param.identities);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(identities) {
  return {
          identities: identities
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.idp.v1alpha1.ListIdentitiesResponse", spec$3(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.identities);
  };
}

function constructor$7(identities) {
  return {
          identities: identities
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.idp.v1alpha1.ListIdentitiesResponse", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListIdentitiesResponse, {
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$3,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

function name$4(param) {
  return ".buhta.idp.v1alpha1.CreateIdentityRequest";
}

function make$4(data, param) {
  return {
          data: data
        };
}

const merge_data = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "data",
            "data"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: IdentityData.name,
                make: IdentityData.make,
                from_proto: IdentityData.from_proto,
                from_proto_exn: IdentityData.from_proto_exn,
                to_proto: IdentityData.to_proto,
                to_proto$p: IdentityData.to_proto$p,
                merge: IdentityData.merge,
                to_json: IdentityData.to_json,
                from_json_exn: IdentityData.from_json_exn,
                from_json: IdentityData.from_json
              })
        ]));

function merge$4(t1, t2) {
  return {
          data: Curry._2(merge_data, t1.data, t2.data)
        };
}

function spec$4(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "data",
                    "data"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: IdentityData.name,
                        make: IdentityData.make,
                        from_proto: IdentityData.from_proto,
                        from_proto_exn: IdentityData.from_proto_exn,
                        to_proto: IdentityData.to_proto,
                        to_proto$p: IdentityData.to_proto$p,
                        merge: IdentityData.merge,
                        to_json: IdentityData.to_json,
                        from_json_exn: IdentityData.from_json_exn,
                        from_json: IdentityData.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
    });

function to_proto$p$4(writer, param) {
  Curry._2(serialize$4, writer, param.data);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(data) {
  return {
          data: data
        };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
    });

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$4, writer);
            });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.idp.v1alpha1.CreateIdentityRequest", spec$4(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.data);
  };
}

function constructor$9(data) {
  return {
          data: data
        };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.idp.v1alpha1.CreateIdentityRequest", spec$4(undefined), constructor$9);
    });

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$4, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CreateIdentityRequest, {
      make: make$4,
      to_proto: to_proto$4,
      from_proto: from_proto$4,
      to_json: to_json$4,
      from_json: from_json$4,
      name: name$4,
      merge: merge$4,
      to_proto$p: to_proto$p$4,
      from_proto_exn: from_proto_exn$4,
      from_json_exn: from_json_exn$4
    });

function name$5(param) {
  return ".buhta.idp.v1alpha1.CreateIdentityResponse";
}

function make$5(identity, param) {
  return {
          identity: identity
        };
}

const $$let$3 = Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity.Buhta.Idp.V1alpha1.Identity;

const merge_identity$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "identity",
            "identity"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              })
        ]));

function merge$5(t1, t2) {
  return {
          identity: Curry._2(merge_identity$1, t1.identity, t2.identity)
        };
}

function spec$5(param) {
  const $$let = Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity.Buhta.Idp.V1alpha1.Identity;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "identity",
                    "identity"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
    });

function to_proto$p$5(writer, param) {
  Curry._2(serialize$5, writer, param.identity);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10(identity) {
  return {
          identity: identity
        };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
    });

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$5, writer);
            });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.idp.v1alpha1.CreateIdentityResponse", spec$5(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.identity);
  };
}

function constructor$11(identity) {
  return {
          identity: identity
        };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.idp.v1alpha1.CreateIdentityResponse", spec$5(undefined), constructor$11);
    });

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$5, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CreateIdentityResponse, {
      make: make$5,
      to_proto: to_proto$5,
      from_proto: from_proto$5,
      to_json: to_json$5,
      from_json: from_json$5,
      name: name$5,
      merge: merge$5,
      to_proto$p: to_proto$p$5,
      from_proto_exn: from_proto_exn$5,
      from_json_exn: from_json_exn$5
    });

function name$6(param) {
  return ".buhta.idp.v1alpha1.UpdateIdentityRequest";
}

function make$6(idOpt, data, param) {
  const id = idOpt !== undefined ? idOpt : "";
  return {
          id: id,
          data: data
        };
}

const merge_id$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_data$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "data",
            "data"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: IdentityData.name,
                make: IdentityData.make,
                from_proto: IdentityData.from_proto,
                from_proto_exn: IdentityData.from_proto_exn,
                to_proto: IdentityData.to_proto,
                to_proto$p: IdentityData.to_proto$p,
                merge: IdentityData.merge,
                to_json: IdentityData.to_json,
                from_json_exn: IdentityData.from_json_exn,
                from_json: IdentityData.from_json
              })
        ]));

function merge$6(t1, t2) {
  return {
          id: Curry._2(merge_id$1, t1.id, t2.id),
          data: Curry._2(merge_data$1, t1.data, t2.data)
        };
}

function spec$6(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "data",
                        "data"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: IdentityData.name,
                            make: IdentityData.make,
                            from_proto: IdentityData.from_proto,
                            from_proto_exn: IdentityData.from_proto_exn,
                            to_proto: IdentityData.to_proto,
                            to_proto$p: IdentityData.to_proto$p,
                            merge: IdentityData.merge,
                            to_json: IdentityData.to_json,
                            from_json_exn: IdentityData.from_json_exn,
                            from_json: IdentityData.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$6(undefined));
    });

function to_proto$p$6(writer, param) {
  Curry._3(serialize$6, writer, param.id, param.data);
}

function to_proto$6(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$6(writer, t);
  return writer;
}

function constructor$12(id, data) {
  return {
          id: id,
          data: data
        };
}

const from_proto_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$6(undefined), constructor$12);
    });

function from_proto$6(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$6, writer);
            });
}

function to_json$6(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.idp.v1alpha1.UpdateIdentityRequest", spec$6(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.data);
  };
}

function constructor$13(id, data) {
  return {
          id: id,
          data: data
        };
}

const from_json_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.idp.v1alpha1.UpdateIdentityRequest", spec$6(undefined), constructor$13);
    });

function from_json$6(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$6, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdateIdentityRequest, {
      make: make$6,
      to_proto: to_proto$6,
      from_proto: from_proto$6,
      to_json: to_json$6,
      from_json: from_json$6,
      name: name$6,
      merge: merge$6,
      to_proto$p: to_proto$p$6,
      from_proto_exn: from_proto_exn$6,
      from_json_exn: from_json_exn$6
    });

function name$7(param) {
  return ".buhta.idp.v1alpha1.UpdateIdentityResponse";
}

function make$7(identity, param) {
  return {
          identity: identity
        };
}

const $$let$4 = Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity.Buhta.Idp.V1alpha1.Identity;

const merge_identity$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "identity",
            "identity"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$4.name,
                make: $$let$4.make,
                from_proto: $$let$4.from_proto,
                from_proto_exn: $$let$4.from_proto_exn,
                to_proto: $$let$4.to_proto,
                to_proto$p: $$let$4.to_proto$p,
                merge: $$let$4.merge,
                to_json: $$let$4.to_json,
                from_json_exn: $$let$4.from_json_exn,
                from_json: $$let$4.from_json
              })
        ]));

function merge$7(t1, t2) {
  return {
          identity: Curry._2(merge_identity$2, t1.identity, t2.identity)
        };
}

function spec$7(param) {
  const $$let = Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity.Buhta.Idp.V1alpha1.Identity;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "identity",
                    "identity"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$7(undefined));
    });

function to_proto$p$7(writer, param) {
  Curry._2(serialize$7, writer, param.identity);
}

function to_proto$7(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$7(writer, t);
  return writer;
}

function constructor$14(identity) {
  return {
          identity: identity
        };
}

const from_proto_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$7(undefined), constructor$14);
    });

function from_proto$7(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$7, writer);
            });
}

function to_json$7(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.idp.v1alpha1.UpdateIdentityResponse", spec$7(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.identity);
  };
}

function constructor$15(identity) {
  return {
          identity: identity
        };
}

const from_json_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.idp.v1alpha1.UpdateIdentityResponse", spec$7(undefined), constructor$15);
    });

function from_json$7(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$7, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdateIdentityResponse, {
      make: make$7,
      to_proto: to_proto$7,
      from_proto: from_proto$7,
      to_json: to_json$7,
      from_json: from_json$7,
      name: name$7,
      merge: merge$7,
      to_proto$p: to_proto$p$7,
      from_proto_exn: from_proto_exn$7,
      from_json_exn: from_json_exn$7
    });

function name$8(param) {
  return ".buhta.idp.v1alpha1.IdentityData";
}

function make$8(family_nameOpt, given_nameOpt, emailOpt, phoneOpt, userpic_id, password, param) {
  const family_name = family_nameOpt !== undefined ? family_nameOpt : "";
  const given_name = given_nameOpt !== undefined ? given_nameOpt : "";
  const email = emailOpt !== undefined ? emailOpt : "";
  const phone = phoneOpt !== undefined ? phoneOpt : "";
  return {
          family_name: family_name,
          given_name: given_name,
          email: email,
          phone: phone,
          userpic_id: userpic_id,
          password: password
        };
}

const merge_family_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "family_name",
            "familyName"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_given_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "given_name",
            "givenName"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_email = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "email",
            "email"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_phone = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "phone",
            "phone"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_userpic_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            5,
            "userpic_id",
            "userpicId"
          ],
          Ocaml_protoc_plugin__Spec.int32_int
        ]));

const merge_password = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            6,
            "password",
            "password"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

function merge$8(t1, t2) {
  return {
          family_name: Curry._2(merge_family_name, t1.family_name, t2.family_name),
          given_name: Curry._2(merge_given_name, t1.given_name, t2.given_name),
          email: Curry._2(merge_email, t1.email, t2.email),
          phone: Curry._2(merge_phone, t1.phone, t2.phone),
          userpic_id: Curry._2(merge_userpic_id, t1.userpic_id, t2.userpic_id),
          password: Curry._2(merge_password, t1.password, t2.password)
        };
}

function spec$8(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "family_name",
                    "familyName"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "given_name",
                        "givenName"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "email",
                            "email"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                4,
                                "phone",
                                "phone"
                              ],
                              Ocaml_protoc_plugin__Spec.string,
                              ""
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                  [
                                    5,
                                    "userpic_id",
                                    "userpicId"
                                  ],
                                  Ocaml_protoc_plugin__Spec.int32_int
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                      [
                                        6,
                                        "password",
                                        "password"
                                      ],
                                      Ocaml_protoc_plugin__Spec.string
                                    ]), Ocaml_protoc_plugin__Spec.nil))))));
}

const serialize$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$8(undefined));
    });

function to_proto$p$8(writer, param) {
  Curry._7(serialize$8, writer, param.family_name, param.given_name, param.email, param.phone, param.userpic_id, param.password);
}

function to_proto$8(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$8(writer, t);
  return writer;
}

function constructor$16(family_name, given_name, email, phone, userpic_id, password) {
  return {
          family_name: family_name,
          given_name: given_name,
          email: email,
          phone: phone,
          userpic_id: userpic_id,
          password: password
        };
}

const from_proto_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$8(undefined), constructor$16);
    });

function from_proto$8(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$8, writer);
            });
}

function to_json$8(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.idp.v1alpha1.IdentityData", spec$8(undefined))(options);
  return function (param) {
    return Curry._6(serialize, param.family_name, param.given_name, param.email, param.phone, param.userpic_id, param.password);
  };
}

function constructor$17(family_name, given_name, email, phone, userpic_id, password) {
  return {
          family_name: family_name,
          given_name: given_name,
          email: email,
          phone: phone,
          userpic_id: userpic_id,
          password: password
        };
}

const from_json_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.idp.v1alpha1.IdentityData", spec$8(undefined), constructor$17);
    });

function from_json$8(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$8, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, IdentityData, {
      make: make$8,
      to_proto: to_proto$8,
      from_proto: from_proto$8,
      to_json: to_json$8,
      from_json: from_json$8,
      name: name$8,
      merge: merge$8,
      to_proto$p: to_proto$p$8,
      from_proto_exn: from_proto_exn$8,
      from_json_exn: from_json_exn$8
    });

const getIdentity_0 = {
  name: GetIdentityRequest.name,
  make: GetIdentityRequest.make,
  from_proto: GetIdentityRequest.from_proto,
  from_proto_exn: GetIdentityRequest.from_proto_exn,
  to_proto: GetIdentityRequest.to_proto,
  to_proto$p: GetIdentityRequest.to_proto$p,
  merge: GetIdentityRequest.merge,
  to_json: GetIdentityRequest.to_json,
  from_json_exn: GetIdentityRequest.from_json_exn,
  from_json: GetIdentityRequest.from_json
};

const getIdentity_1 = {
  name: GetIdentityResponse.name,
  make: GetIdentityResponse.make,
  from_proto: GetIdentityResponse.from_proto,
  from_proto_exn: GetIdentityResponse.from_proto_exn,
  to_proto: GetIdentityResponse.to_proto,
  to_proto$p: GetIdentityResponse.to_proto$p,
  merge: GetIdentityResponse.merge,
  to_json: GetIdentityResponse.to_json,
  from_json_exn: GetIdentityResponse.from_json_exn,
  from_json: GetIdentityResponse.from_json
};

const getIdentity = [
  getIdentity_0,
  getIdentity_1
];

const listIdentities_0 = {
  name: ListIdentitiesRequest.name,
  make: ListIdentitiesRequest.make,
  from_proto: ListIdentitiesRequest.from_proto,
  from_proto_exn: ListIdentitiesRequest.from_proto_exn,
  to_proto: ListIdentitiesRequest.to_proto,
  to_proto$p: ListIdentitiesRequest.to_proto$p,
  merge: ListIdentitiesRequest.merge,
  to_json: ListIdentitiesRequest.to_json,
  from_json_exn: ListIdentitiesRequest.from_json_exn,
  from_json: ListIdentitiesRequest.from_json
};

const listIdentities_1 = {
  name: ListIdentitiesResponse.name,
  make: ListIdentitiesResponse.make,
  from_proto: ListIdentitiesResponse.from_proto,
  from_proto_exn: ListIdentitiesResponse.from_proto_exn,
  to_proto: ListIdentitiesResponse.to_proto,
  to_proto$p: ListIdentitiesResponse.to_proto$p,
  merge: ListIdentitiesResponse.merge,
  to_json: ListIdentitiesResponse.to_json,
  from_json_exn: ListIdentitiesResponse.from_json_exn,
  from_json: ListIdentitiesResponse.from_json
};

const listIdentities = [
  listIdentities_0,
  listIdentities_1
];

const createIdentity_0 = {
  name: CreateIdentityRequest.name,
  make: CreateIdentityRequest.make,
  from_proto: CreateIdentityRequest.from_proto,
  from_proto_exn: CreateIdentityRequest.from_proto_exn,
  to_proto: CreateIdentityRequest.to_proto,
  to_proto$p: CreateIdentityRequest.to_proto$p,
  merge: CreateIdentityRequest.merge,
  to_json: CreateIdentityRequest.to_json,
  from_json_exn: CreateIdentityRequest.from_json_exn,
  from_json: CreateIdentityRequest.from_json
};

const createIdentity_1 = {
  name: CreateIdentityResponse.name,
  make: CreateIdentityResponse.make,
  from_proto: CreateIdentityResponse.from_proto,
  from_proto_exn: CreateIdentityResponse.from_proto_exn,
  to_proto: CreateIdentityResponse.to_proto,
  to_proto$p: CreateIdentityResponse.to_proto$p,
  merge: CreateIdentityResponse.merge,
  to_json: CreateIdentityResponse.to_json,
  from_json_exn: CreateIdentityResponse.from_json_exn,
  from_json: CreateIdentityResponse.from_json
};

const createIdentity = [
  createIdentity_0,
  createIdentity_1
];

const updateIdentity_0 = {
  name: UpdateIdentityRequest.name,
  make: UpdateIdentityRequest.make,
  from_proto: UpdateIdentityRequest.from_proto,
  from_proto_exn: UpdateIdentityRequest.from_proto_exn,
  to_proto: UpdateIdentityRequest.to_proto,
  to_proto$p: UpdateIdentityRequest.to_proto$p,
  merge: UpdateIdentityRequest.merge,
  to_json: UpdateIdentityRequest.to_json,
  from_json_exn: UpdateIdentityRequest.from_json_exn,
  from_json: UpdateIdentityRequest.from_json
};

const updateIdentity_1 = {
  name: UpdateIdentityResponse.name,
  make: UpdateIdentityResponse.make,
  from_proto: UpdateIdentityResponse.from_proto,
  from_proto_exn: UpdateIdentityResponse.from_proto_exn,
  to_proto: UpdateIdentityResponse.to_proto,
  to_proto$p: UpdateIdentityResponse.to_proto$p,
  merge: UpdateIdentityResponse.merge,
  to_json: UpdateIdentityResponse.to_json,
  from_json_exn: UpdateIdentityResponse.from_json_exn,
  from_json: UpdateIdentityResponse.from_json
};

const updateIdentity = [
  updateIdentity_0,
  updateIdentity_1
];

const V1alpha1_AdminIdentityService = {
  GetIdentity: {
    name: "/buhta.idp.v1alpha1.AdminIdentityService/GetIdentity",
    package_name: "buhta.idp.v1alpha1",
    service_name: "AdminIdentityService",
    method_name: "GetIdentity",
    $$Request: {
      name: GetIdentityRequest.name,
      make: GetIdentityRequest.make,
      from_proto: GetIdentityRequest.from_proto,
      from_proto_exn: GetIdentityRequest.from_proto_exn,
      to_proto: GetIdentityRequest.to_proto,
      to_proto$p: GetIdentityRequest.to_proto$p,
      merge: GetIdentityRequest.merge,
      to_json: GetIdentityRequest.to_json,
      from_json_exn: GetIdentityRequest.from_json_exn,
      from_json: GetIdentityRequest.from_json
    },
    $$Response: {
      name: GetIdentityResponse.name,
      make: GetIdentityResponse.make,
      from_proto: GetIdentityResponse.from_proto,
      from_proto_exn: GetIdentityResponse.from_proto_exn,
      to_proto: GetIdentityResponse.to_proto,
      to_proto$p: GetIdentityResponse.to_proto$p,
      merge: GetIdentityResponse.merge,
      to_json: GetIdentityResponse.to_json,
      from_json_exn: GetIdentityResponse.from_json_exn,
      from_json: GetIdentityResponse.from_json
    }
  },
  getIdentity: getIdentity,
  ListIdentities: {
    name: "/buhta.idp.v1alpha1.AdminIdentityService/ListIdentities",
    package_name: "buhta.idp.v1alpha1",
    service_name: "AdminIdentityService",
    method_name: "ListIdentities",
    $$Request: {
      name: ListIdentitiesRequest.name,
      make: ListIdentitiesRequest.make,
      from_proto: ListIdentitiesRequest.from_proto,
      from_proto_exn: ListIdentitiesRequest.from_proto_exn,
      to_proto: ListIdentitiesRequest.to_proto,
      to_proto$p: ListIdentitiesRequest.to_proto$p,
      merge: ListIdentitiesRequest.merge,
      to_json: ListIdentitiesRequest.to_json,
      from_json_exn: ListIdentitiesRequest.from_json_exn,
      from_json: ListIdentitiesRequest.from_json
    },
    $$Response: {
      name: ListIdentitiesResponse.name,
      make: ListIdentitiesResponse.make,
      from_proto: ListIdentitiesResponse.from_proto,
      from_proto_exn: ListIdentitiesResponse.from_proto_exn,
      to_proto: ListIdentitiesResponse.to_proto,
      to_proto$p: ListIdentitiesResponse.to_proto$p,
      merge: ListIdentitiesResponse.merge,
      to_json: ListIdentitiesResponse.to_json,
      from_json_exn: ListIdentitiesResponse.from_json_exn,
      from_json: ListIdentitiesResponse.from_json
    }
  },
  listIdentities: listIdentities,
  CreateIdentity: {
    name: "/buhta.idp.v1alpha1.AdminIdentityService/CreateIdentity",
    package_name: "buhta.idp.v1alpha1",
    service_name: "AdminIdentityService",
    method_name: "CreateIdentity",
    $$Request: {
      name: CreateIdentityRequest.name,
      make: CreateIdentityRequest.make,
      from_proto: CreateIdentityRequest.from_proto,
      from_proto_exn: CreateIdentityRequest.from_proto_exn,
      to_proto: CreateIdentityRequest.to_proto,
      to_proto$p: CreateIdentityRequest.to_proto$p,
      merge: CreateIdentityRequest.merge,
      to_json: CreateIdentityRequest.to_json,
      from_json_exn: CreateIdentityRequest.from_json_exn,
      from_json: CreateIdentityRequest.from_json
    },
    $$Response: {
      name: CreateIdentityResponse.name,
      make: CreateIdentityResponse.make,
      from_proto: CreateIdentityResponse.from_proto,
      from_proto_exn: CreateIdentityResponse.from_proto_exn,
      to_proto: CreateIdentityResponse.to_proto,
      to_proto$p: CreateIdentityResponse.to_proto$p,
      merge: CreateIdentityResponse.merge,
      to_json: CreateIdentityResponse.to_json,
      from_json_exn: CreateIdentityResponse.from_json_exn,
      from_json: CreateIdentityResponse.from_json
    }
  },
  createIdentity: createIdentity,
  UpdateIdentity: {
    name: "/buhta.idp.v1alpha1.AdminIdentityService/UpdateIdentity",
    package_name: "buhta.idp.v1alpha1",
    service_name: "AdminIdentityService",
    method_name: "UpdateIdentity",
    $$Request: {
      name: UpdateIdentityRequest.name,
      make: UpdateIdentityRequest.make,
      from_proto: UpdateIdentityRequest.from_proto,
      from_proto_exn: UpdateIdentityRequest.from_proto_exn,
      to_proto: UpdateIdentityRequest.to_proto,
      to_proto$p: UpdateIdentityRequest.to_proto$p,
      merge: UpdateIdentityRequest.merge,
      to_json: UpdateIdentityRequest.to_json,
      from_json_exn: UpdateIdentityRequest.from_json_exn,
      from_json: UpdateIdentityRequest.from_json
    },
    $$Response: {
      name: UpdateIdentityResponse.name,
      make: UpdateIdentityResponse.make,
      from_proto: UpdateIdentityResponse.from_proto,
      from_proto_exn: UpdateIdentityResponse.from_proto_exn,
      to_proto: UpdateIdentityResponse.to_proto,
      to_proto$p: UpdateIdentityResponse.to_proto$p,
      merge: UpdateIdentityResponse.merge,
      to_json: UpdateIdentityResponse.to_json,
      from_json_exn: UpdateIdentityResponse.from_json_exn,
      from_json: UpdateIdentityResponse.from_json
    }
  },
  updateIdentity: updateIdentity
};

const V1alpha1 = {
  GetIdentityRequest: GetIdentityRequest,
  GetIdentityResponse: GetIdentityResponse,
  ListIdentitiesRequest: ListIdentitiesRequest,
  ListIdentitiesResponse: ListIdentitiesResponse,
  CreateIdentityRequest: CreateIdentityRequest,
  CreateIdentityResponse: CreateIdentityResponse,
  UpdateIdentityRequest: UpdateIdentityRequest,
  UpdateIdentityResponse: UpdateIdentityResponse,
  IdentityData: IdentityData,
  AdminIdentityService: V1alpha1_AdminIdentityService
};

const Idp = {
  V1alpha1: V1alpha1
};

const Buhta = {
  Idp: Idp
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* GetIdentityRequest Not a pure module */
